import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { getDefaultUserMeTenant } from '@/features/auth/models'
import { PERFORMANCE_MANAGEMENT_ROLE, USER_ROLE } from '@/libs/api/types'

export const Route = createFileRoute(
  '/_protected/$tenantKey/_performance_managements'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (
      auth.user.performanceManagementRole ===
        PERFORMANCE_MANAGEMENT_ROLE.NONE &&
      auth.user.userRole !== USER_ROLE.ADMIN
    ) {
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}`
      })
    }
  },
  component: () => <Outlet />
})
